var map = {
	"./activities.svg": 77024,
	"./activity.svg": 46455,
	"./add-file.svg": 75957,
	"./add-folder.svg": 41524,
	"./add.svg": 3861,
	"./addTool.svg": 91034,
	"./addnocolor.svg": 20610,
	"./allSelect.svg": 9516,
	"./arrow-bottom1.svg": 73880,
	"./arrow-botton.svg": 35602,
	"./arrow-top.svg": 86455,
	"./arrow-top1.svg": 49026,
	"./arrow-y.svg": 28598,
	"./articulation.svg": 9147,
	"./bianji.svg": 29270,
	"./bianmaceyan.svg": 93049,
	"./bilibili-line.svg": 26267,
	"./blue-bottom.svg": 41525,
	"./cancel.svg": 20136,
	"./checkbox.svg": 76626,
	"./close.svg": 72004,
	"./closeIconModal.svg": 60137,
	"./closeIconhover.svg": 85942,
	"./closee.svg": 75637,
	"./closeenv.svg": 85957,
	"./closeicon-hover.svg": 17972,
	"./closeicon.svg": 74993,
	"./codeplayer.svg": 10735,
	"./compress.svg": 8258,
	"./console.svg": 41962,
	"./container-bottom.svg": 9692,
	"./container-close.svg": 10745,
	"./cpu.svg": 33191,
	"./creatNovalue.svg": 35605,
	"./css.svg": 598,
	"./daoru.svg": 42182,
	"./delete.svg": 12783,
	"./deletee-hover.svg": 80765,
	"./deletee.svg": 22730,
	"./deleteno.svg": 62080,
	"./down.svg": 52098,
	"./download.svg": 20487,
	"./edit.svg": 80887,
	"./editor.svg": 87367,
	"./editorr.svg": 80921,
	"./empty.svg": 79204,
	"./empty1.svg": 6012,
	"./env-1.svg": 2829,
	"./env-2.svg": 94871,
	"./env-icon.svg": 68663,
	"./env.svg": 32329,
	"./exam.svg": 3356,
	"./exitBtn.svg": 5314,
	"./expand.svg": 79139,
	"./experiment.svg": 68680,
	"./fail.svg": 67330,
	"./fangda.svg": 73403,
	"./file.svg": 39848,
	"./fold.svg": 39807,
	"./folder.svg": 2740,
	"./frame.svg": 67729,
	"./fresh.svg": 46056,
	"./gitIcon.svg": 18566,
	"./gpt.svg": 59689,
	"./help-hover.svg": 92455,
	"./help.svg": 13158,
	"./helpIcon.svg": 46436,
	"./helpp.svg": 20361,
	"./hoverline.svg": 94744,
	"./html.svg": 72490,
	"./hui-exam.svg": 30532,
	"./hui-gantanhao.svg": 2317,
	"./inviteClose.svg": 72505,
	"./inviteIcon.svg": 84598,
	"./itab-default.svg": 74906,
	"./java.svg": 24106,
	"./jiahao.svg": 93215,
	"./jianxiao.svg": 1708,
	"./js.svg": 94755,
	"./json.svg": 52276,
	"./left-arrow.svg": 60762,
	"./left-resource.svg": 53596,
	"./left-tool.svg": 19042,
	"./loading.svg": 89629,
	"./lock.svg": 41052,
	"./mark-bot.svg": 51882,
	"./mark-top.svg": 43986,
	"./mark.svg": 20165,
	"./markdown.svg": 34678,
	"./md.svg": 22054,
	"./memory.svg": 97294,
	"./modal-close.svg": 24412,
	"./modalclose.svg": 28994,
	"./more.svg": 97819,
	"./movelineadd.svg": 51062,
	"./movetrack.svg": 23048,
	"./noSelect.svg": 33398,
	"./nodata.svg": 54195,
	"./nopass.svg": 99309,
	"./online.svg": 35281,
	"./openwin.svg": 24521,
	"./passIcon.svg": 56039,
	"./pause.svg": 31117,
	"./pdf.svg": 25094,
	"./play.svg": 69941,
	"./player.svg": 18723,
	"./point.svg": 6541,
	"./project-mark.svg": 24189,
	"./project-run.svg": 61174,
	"./promptIcon.svg": 3080,
	"./python.svg": 45118,
	"./ques-add.svg": 73228,
	"./ques-choice.svg": 95756,
	"./ques-fold.svg": 8606,
	"./ques-footer-publish.svg": 51129,
	"./ques-footer-top.svg": 9844,
	"./ques-loading.svg": 79576,
	"./ques-notip.svg": 62873,
	"./ques-recover.svg": 96173,
	"./ques-remove.svg": 88268,
	"./ques-return.svg": 61979,
	"./ques-sandian.svg": 77774,
	"./ques-tip.svg": 34511,
	"./question.svg": 56298,
	"./radio.svg": 48241,
	"./refresh.svg": 53058,
	"./reset.svg": 91128,
	"./resetResource.svg": 26575,
	"./resource.svg": 8413,
	"./resourceIcon.svg": 61486,
	"./resourceLoaing.svg": 39739,
	"./resourcefile.svg": 14410,
	"./right-ai.svg": 88321,
	"./right-arrow.svg": 88618,
	"./right-bushu.svg": 27365,
	"./right-create.svg": 63549,
	"./right-env.svg": 95440,
	"./right-file.svg": 85012,
	"./right-note.svg": 78583,
	"./right-quesandans.svg": 30947,
	"./right-setting.svg": 37398,
	"./right.svg": 95490,
	"./run.svg": 60121,
	"./save.svg": 75369,
	"./select.svg": 88261,
	"./shanchu.svg": 12712,
	"./shell.svg": 85866,
	"./shiliyanshi.svg": 80247,
	"./soueceDetele.svg": 89535,
	"./soueceDeteleHover.svg": 16654,
	"./sourceEdit.svg": 75080,
	"./sourceEditHover.svg": 43901,
	"./studyNovalue.svg": 63258,
	"./subtitle-sb.svg": 80889,
	"./subtitle-upload.svg": 68613,
	"./subtitle.svg": 33159,
	"./success.svg": 34782,
	"./sure.svg": 52320,
	"./text.svg": 27633,
	"./time.svg": 65787,
	"./tip.svg": 91472,
	"./tip1.svg": 77317,
	"./tipred.svg": 20510,
	"./tools-add.svg": 53160,
	"./tools-close.svg": 67050,
	"./tools-manage.svg": 85141,
	"./tree-add.svg": 64911,
	"./tree-bottom.svg": 87121,
	"./tree-file.svg": 71233,
	"./tree-folder-notopen.svg": 41826,
	"./tree-folder-open.svg": 93739,
	"./tree-fresh.svg": 76560,
	"./tree-more.svg": 3202,
	"./tree-text.svg": 65851,
	"./tree-video.svg": 53644,
	"./tw.svg": 32518,
	"./txt.svg": 88614,
	"./unfold.svg": 95077,
	"./up-b.svg": 9134,
	"./up-y.svg": 38746,
	"./uploadIcon.svg": 58041,
	"./user.svg": 40682,
	"./validate.svg": 51121,
	"./video-parse.svg": 96807,
	"./video-text.svg": 78679,
	"./video.svg": 1014,
	"./video1.svg": 25399,
	"./video2.svg": 35093,
	"./videoeditor.svg": 30933,
	"./videoplayer.svg": 75486,
	"./voice-close.svg": 90886,
	"./voice.svg": 81919,
	"./warning.svg": 17367,
	"./warning1.svg": 57036,
	"./warning2.svg": 11226,
	"./webview.svg": 99210,
	"./word.svg": 56059,
	"./xuanzeti.svg": 43850,
	"./yellowenhao.svg": 76168,
	"./yellowtime.svg": 16388,
	"./zanting.svg": 3503,
	"./zhaiyaojiedian.svg": 52822,
	"./zhushi.svg": 78643,
	"icons/svg/activities.svg": 77024,
	"icons/svg/activity.svg": 46455,
	"icons/svg/add-file.svg": 75957,
	"icons/svg/add-folder.svg": 41524,
	"icons/svg/add.svg": 3861,
	"icons/svg/addTool.svg": 91034,
	"icons/svg/addnocolor.svg": 20610,
	"icons/svg/allSelect.svg": 9516,
	"icons/svg/arrow-bottom1.svg": 73880,
	"icons/svg/arrow-botton.svg": 35602,
	"icons/svg/arrow-top.svg": 86455,
	"icons/svg/arrow-top1.svg": 49026,
	"icons/svg/arrow-y.svg": 28598,
	"icons/svg/articulation.svg": 9147,
	"icons/svg/bianji.svg": 29270,
	"icons/svg/bianmaceyan.svg": 93049,
	"icons/svg/bilibili-line.svg": 26267,
	"icons/svg/blue-bottom.svg": 41525,
	"icons/svg/cancel.svg": 20136,
	"icons/svg/checkbox.svg": 76626,
	"icons/svg/close.svg": 72004,
	"icons/svg/closeIconModal.svg": 60137,
	"icons/svg/closeIconhover.svg": 85942,
	"icons/svg/closee.svg": 75637,
	"icons/svg/closeenv.svg": 85957,
	"icons/svg/closeicon-hover.svg": 17972,
	"icons/svg/closeicon.svg": 74993,
	"icons/svg/codeplayer.svg": 10735,
	"icons/svg/compress.svg": 8258,
	"icons/svg/console.svg": 41962,
	"icons/svg/container-bottom.svg": 9692,
	"icons/svg/container-close.svg": 10745,
	"icons/svg/cpu.svg": 33191,
	"icons/svg/creatNovalue.svg": 35605,
	"icons/svg/css.svg": 598,
	"icons/svg/daoru.svg": 42182,
	"icons/svg/delete.svg": 12783,
	"icons/svg/deletee-hover.svg": 80765,
	"icons/svg/deletee.svg": 22730,
	"icons/svg/deleteno.svg": 62080,
	"icons/svg/down.svg": 52098,
	"icons/svg/download.svg": 20487,
	"icons/svg/edit.svg": 80887,
	"icons/svg/editor.svg": 87367,
	"icons/svg/editorr.svg": 80921,
	"icons/svg/empty.svg": 79204,
	"icons/svg/empty1.svg": 6012,
	"icons/svg/env-1.svg": 2829,
	"icons/svg/env-2.svg": 94871,
	"icons/svg/env-icon.svg": 68663,
	"icons/svg/env.svg": 32329,
	"icons/svg/exam.svg": 3356,
	"icons/svg/exitBtn.svg": 5314,
	"icons/svg/expand.svg": 79139,
	"icons/svg/experiment.svg": 68680,
	"icons/svg/fail.svg": 67330,
	"icons/svg/fangda.svg": 73403,
	"icons/svg/file.svg": 39848,
	"icons/svg/fold.svg": 39807,
	"icons/svg/folder.svg": 2740,
	"icons/svg/frame.svg": 67729,
	"icons/svg/fresh.svg": 46056,
	"icons/svg/gitIcon.svg": 18566,
	"icons/svg/gpt.svg": 59689,
	"icons/svg/help-hover.svg": 92455,
	"icons/svg/help.svg": 13158,
	"icons/svg/helpIcon.svg": 46436,
	"icons/svg/helpp.svg": 20361,
	"icons/svg/hoverline.svg": 94744,
	"icons/svg/html.svg": 72490,
	"icons/svg/hui-exam.svg": 30532,
	"icons/svg/hui-gantanhao.svg": 2317,
	"icons/svg/inviteClose.svg": 72505,
	"icons/svg/inviteIcon.svg": 84598,
	"icons/svg/itab-default.svg": 74906,
	"icons/svg/java.svg": 24106,
	"icons/svg/jiahao.svg": 93215,
	"icons/svg/jianxiao.svg": 1708,
	"icons/svg/js.svg": 94755,
	"icons/svg/json.svg": 52276,
	"icons/svg/left-arrow.svg": 60762,
	"icons/svg/left-resource.svg": 53596,
	"icons/svg/left-tool.svg": 19042,
	"icons/svg/loading.svg": 89629,
	"icons/svg/lock.svg": 41052,
	"icons/svg/mark-bot.svg": 51882,
	"icons/svg/mark-top.svg": 43986,
	"icons/svg/mark.svg": 20165,
	"icons/svg/markdown.svg": 34678,
	"icons/svg/md.svg": 22054,
	"icons/svg/memory.svg": 97294,
	"icons/svg/modal-close.svg": 24412,
	"icons/svg/modalclose.svg": 28994,
	"icons/svg/more.svg": 97819,
	"icons/svg/movelineadd.svg": 51062,
	"icons/svg/movetrack.svg": 23048,
	"icons/svg/noSelect.svg": 33398,
	"icons/svg/nodata.svg": 54195,
	"icons/svg/nopass.svg": 99309,
	"icons/svg/online.svg": 35281,
	"icons/svg/openwin.svg": 24521,
	"icons/svg/passIcon.svg": 56039,
	"icons/svg/pause.svg": 31117,
	"icons/svg/pdf.svg": 25094,
	"icons/svg/play.svg": 69941,
	"icons/svg/player.svg": 18723,
	"icons/svg/point.svg": 6541,
	"icons/svg/project-mark.svg": 24189,
	"icons/svg/project-run.svg": 61174,
	"icons/svg/promptIcon.svg": 3080,
	"icons/svg/python.svg": 45118,
	"icons/svg/ques-add.svg": 73228,
	"icons/svg/ques-choice.svg": 95756,
	"icons/svg/ques-fold.svg": 8606,
	"icons/svg/ques-footer-publish.svg": 51129,
	"icons/svg/ques-footer-top.svg": 9844,
	"icons/svg/ques-loading.svg": 79576,
	"icons/svg/ques-notip.svg": 62873,
	"icons/svg/ques-recover.svg": 96173,
	"icons/svg/ques-remove.svg": 88268,
	"icons/svg/ques-return.svg": 61979,
	"icons/svg/ques-sandian.svg": 77774,
	"icons/svg/ques-tip.svg": 34511,
	"icons/svg/question.svg": 56298,
	"icons/svg/radio.svg": 48241,
	"icons/svg/refresh.svg": 53058,
	"icons/svg/reset.svg": 91128,
	"icons/svg/resetResource.svg": 26575,
	"icons/svg/resource.svg": 8413,
	"icons/svg/resourceIcon.svg": 61486,
	"icons/svg/resourceLoaing.svg": 39739,
	"icons/svg/resourcefile.svg": 14410,
	"icons/svg/right-ai.svg": 88321,
	"icons/svg/right-arrow.svg": 88618,
	"icons/svg/right-bushu.svg": 27365,
	"icons/svg/right-create.svg": 63549,
	"icons/svg/right-env.svg": 95440,
	"icons/svg/right-file.svg": 85012,
	"icons/svg/right-note.svg": 78583,
	"icons/svg/right-quesandans.svg": 30947,
	"icons/svg/right-setting.svg": 37398,
	"icons/svg/right.svg": 95490,
	"icons/svg/run.svg": 60121,
	"icons/svg/save.svg": 75369,
	"icons/svg/select.svg": 88261,
	"icons/svg/shanchu.svg": 12712,
	"icons/svg/shell.svg": 85866,
	"icons/svg/shiliyanshi.svg": 80247,
	"icons/svg/soueceDetele.svg": 89535,
	"icons/svg/soueceDeteleHover.svg": 16654,
	"icons/svg/sourceEdit.svg": 75080,
	"icons/svg/sourceEditHover.svg": 43901,
	"icons/svg/studyNovalue.svg": 63258,
	"icons/svg/subtitle-sb.svg": 80889,
	"icons/svg/subtitle-upload.svg": 68613,
	"icons/svg/subtitle.svg": 33159,
	"icons/svg/success.svg": 34782,
	"icons/svg/sure.svg": 52320,
	"icons/svg/text.svg": 27633,
	"icons/svg/time.svg": 65787,
	"icons/svg/tip.svg": 91472,
	"icons/svg/tip1.svg": 77317,
	"icons/svg/tipred.svg": 20510,
	"icons/svg/tools-add.svg": 53160,
	"icons/svg/tools-close.svg": 67050,
	"icons/svg/tools-manage.svg": 85141,
	"icons/svg/tree-add.svg": 64911,
	"icons/svg/tree-bottom.svg": 87121,
	"icons/svg/tree-file.svg": 71233,
	"icons/svg/tree-folder-notopen.svg": 41826,
	"icons/svg/tree-folder-open.svg": 93739,
	"icons/svg/tree-fresh.svg": 76560,
	"icons/svg/tree-more.svg": 3202,
	"icons/svg/tree-text.svg": 65851,
	"icons/svg/tree-video.svg": 53644,
	"icons/svg/tw.svg": 32518,
	"icons/svg/txt.svg": 88614,
	"icons/svg/unfold.svg": 95077,
	"icons/svg/up-b.svg": 9134,
	"icons/svg/up-y.svg": 38746,
	"icons/svg/uploadIcon.svg": 58041,
	"icons/svg/user.svg": 40682,
	"icons/svg/validate.svg": 51121,
	"icons/svg/video-parse.svg": 96807,
	"icons/svg/video-text.svg": 78679,
	"icons/svg/video.svg": 1014,
	"icons/svg/video1.svg": 25399,
	"icons/svg/video2.svg": 35093,
	"icons/svg/videoeditor.svg": 30933,
	"icons/svg/videoplayer.svg": 75486,
	"icons/svg/voice-close.svg": 90886,
	"icons/svg/voice.svg": 81919,
	"icons/svg/warning.svg": 17367,
	"icons/svg/warning1.svg": 57036,
	"icons/svg/warning2.svg": 11226,
	"icons/svg/webview.svg": 99210,
	"icons/svg/word.svg": 56059,
	"icons/svg/xuanzeti.svg": 43850,
	"icons/svg/yellowenhao.svg": 76168,
	"icons/svg/yellowtime.svg": 16388,
	"icons/svg/zanting.svg": 3503,
	"icons/svg/zhaiyaojiedian.svg": 52822,
	"icons/svg/zhushi.svg": 78643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40240;